import React,{useState,useEffect,useRef} from 'react';
import {connect} from 'react-redux';
import {currentRouteSet, itemCodeSet} from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'; 
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import {pathSpliter,dateTimeFormat,currentDateTime,getDateTimeFromISODT,currentDateStartTime,currentDateEndTime} from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import { APP_URL, API_URL } from "../../config.js";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import _ from 'lodash';
import Barcode from 'react-barcode';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import InstitutionProfile from '../commons/institution_profile'


import commaNumber from 'comma-number';

import "../commons.css";
import { useBarcode } from 'react-barcodes';


import { useHistory } from "react-router-dom";


import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';


let format = commaNumber.bindWith(',', '.')

const PurchaseRecord = ({location,currentRoute,currentRouteSet,authInfo})=>{
    const classes = useStyles();
    useEffect(()=>{
        currentRouteSet(pathSpliter(location.pathname,1));

       

         axios.post(`${API_URL}/api/get-items`,{itemId:parseFloat(pathSpliter(location.pathname,3))},{headers:{'auth-token':authInfo.token}}).then(res=>{
            printSet(true)
            if(res.data.length !=0){
                item_code_set(res.data[0].item_code)
                itemInfoSet(res.data[0]);
            }
         });
    },[]);
    let [users,usersSet] = useState([]);
    const history = useHistory();

    let [item_code,item_code_set] = useState('');
    let [bar_code_qty,bar_code_qty_set] = useState(99);
    
    let [suppliers,suppliersSet] = useState([]);
    let [materials,materialsSet] = useState([]);


    let [itemInfo,itemInfoSet] = useState([]);

    let [selectedSearchType,selectedSearchTypeSet] = useState({searchType:'All'})
    let [selectedMaterial,selectedMaterialSet] = useState(null)
    let [selectedUser,selectedUserSet] = useState(null)


    let employeeRef = React.useRef(null)
    let [searchResult,searchResultSet] = useState([]);
    let [print,printSet] = useState(false);


   


    let [byDateTime,byDateTimeSet] = useState({
          dateTimeFrom: currentDateStartTime(),
          dateTimeTo:currentDateEndTime()
    })

  



    



    let [searchTypes,searchTypesSet] = useState([{searchType:'All'},
    {searchType:'By User'}]);

    
    let getSearchResult = async ()=>{

        let url = `${API_URL}/api/get-materials`;

          if(selectedSearchType == null){
            swal({
              title:'Select search Type',
              icon:'warning',
           })
           return false
          }


            
        let reqPayload = {
            userId: selectedUser != null && selectedSearchType.searchType=='By User' ?selectedUser.user_id:null,
            fromDate: byDateTime.dateTimeFrom,
            toDate: byDateTime.dateTimeTo,
        }

       

        await axios.post(`${url}`,reqPayload,{headers:{'auth-token':authInfo.token}}).then(res=>{
           printSet(true)
           searchResultSet(res.data);

            
        });
    }

    

    // const { inputRef } = useBarcode({
    //   value: `${item_code==''?'Product Code':item_code}`,
    //   options: {
    //     background: '#ffffff',
    //     width:1,
    //     height:30,
    //     margin:0,
    //     displayValue: false,

    //   }
    // });





    const BarCodeItem = ({barcodeValue}) => {

  const { inputRef } = useBarcode({
    value: barcodeValue,
    options: {
           background: '#ffffff',
        width:1,
        height:30,
        margin:0,
        displayValue: false,
    },
  });

  return <>
       <p style={{padding:'0px',marginBottom: '0px',
        marginTop: '-10px',fontSize:'14px',color: '#222',
        fontWeight: 'bold',fontFamily:'sans-serif',fontSize:'18px',}}> {   itemInfo.item_name != undefined ?itemInfo.item_name.substring(0,15):''}</p>

            <svg ref={inputRef}  style={{fontSize:'12px'}} />
            <p style={{padding:'0px',marginTop:'1px',marginBottom: '-3px',fontFamily:'sans-serif',fontSize:'12px'}}>{item_code}</p>
            {/* <p style={{padding:'0px',marginTop:'-2px',marginBottom: '-1px',fontWeight: 'bold',fontFamily:'sans-serif'}}>{'9'+parseFloat(itemInfo.wholesaler_rate).toFixed(0)+'1'}</p> */}
            <p style={{margin:'0px',padding:'0px',fontFamily:'sans-serif',fontSize:'12px'}}>TK {format(parseFloat(itemInfo.sale_rate).toFixed(2))}</p>
  </>;
};

const BarCodeTest = (props) => {
  var data = [
    {
      barCodeValue: "123",
    }
  ];

// how can I set the value property as I iterate through data[]?  
return <>{data && data.map((item, index) => 
<BarCodeItem key={index} barcodeValue={item.barCodeValue}  />
)}</>;
};















const items = []

for (var i = 0; i < bar_code_qty; i++) {
    items.push(<>


<Grid item xs={1} sm={1} style={{margin:'10px'}} >
<BarCodeTest/>

</Grid>


        
    </>)
}



    let ReportDom = React.forwardRef((props,ref)=>{
        return(
          <Paper>

          
          <Grid container className={classes.paper} ref={ref} >
               {/* <InstitutionProfile /> */}

          
 




  {/* <div > */}
        {/* <Grid item xs={12} sm={1}>
        <p style={{padding:'0px',marginBottom: '0px',
        marginTop: '-10px',fontSize:'14px',color: '#222',
        fontWeight: 'bold',fontFamily:'sans-serif',fontSize:'18px'}}> {   itemInfo.item_name != undefined ?itemInfo.item_name.substring(0,15):''}</p>

            <svg ref={inputRef}  style={{fontSize:'12px'}} />
            <p style={{padding:'0px',marginTop:'1px',marginBottom: '-3px',fontFamily:'sans-serif',fontSize:'14px'}}>{item_code}</p>
            <p style={{padding:'0px',marginTop:'-2px',marginBottom: '-1px',fontWeight: 'bold',fontFamily:'sans-serif'}}>{'9'+parseFloat(itemInfo.wholesaler_rate).toFixed(0)+'1'}</p>
            <p style={{margin:'0px',padding:'0px',fontFamily:'sans-serif',fontSize:'15px'}}>TK {format(parseFloat(itemInfo.sale_rate).toFixed(2))}</p>
        </Grid> */}



    

{items}


    




      {/* <p style={{margin:'0px',padding:'0px',transform: 'rotate(90deg)', marginLeft:' 124px',
    marginTop:'-24px'}}>Fair Touch</p> */}

  

  

      





   

     
</Grid>
</Paper>
       )
      })
const reportRef = useRef();

    
      return(
          <div className={classes.root}> 
<Paper className={classes.paper} style={{marginTop:'-25px',marginBottom:'5px'}}>
<h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
    marginBottom: '12px'}}>Product BarCode Generator</h4>
<Grid container spacing={2}>
        <Grid item xs={12} sm={3}  > 
            <TextField  type="text" autoComplete='off'   className={classes.fullWidth}  value={item_code} 
            label="Product Code" name="item_code" variant="outlined" size="small" onChange={(e)=>item_code_set(e.target.value)} />
        </Grid>



        <Grid item xs={12} sm={3} style={{display:''}} > 
            <TextField  type="number" autoComplete='off'   className={classes.fullWidth}  value={bar_code_qty} 
            label="Bar Code Quantity" name="bar_code_qty" variant="outlined" size="small" onChange={(e)=>bar_code_qty_set(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={3}  > 
        <Button style={{marginTop: '10px',fontSize:'9px'}}
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            onClick={()=>history.push(`/administration/items-manage`)        }
        >
        Back To Product Page
      </Button>
        </Grid>
       
        </Grid>
        </Paper>
        
   
        {
        print?(
          <Grid container >
          <Grid item xs={12} sm={12} >
            <Paper style={{borderRadius:'0px',marginTop: '-7px'}}>
            <ReactToPrint
                        trigger={() => <PrintIcon  style={{cursor:'pointer',marginLeft: '30px',marginTop: '3px',marginBottom: '-8px'}} />}
                        content={() => reportRef.current}
                      />
            </Paper>
         
          </Grid>
      </Grid>
        ):''
      }
            <ReportDom ref={reportRef} /> 



          </div>
     )
    }


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    inputField:{
      width:'100%',
      marginTop:'5px'
    },
    plusLinkDiv:{
      position:'relative'  
    },
    plusLink:{
      margin: 0,
      padding: 0,
      marginTop: '-21px',
      fontSize: '29px',
      height: '21px',
      textAlign: 'right',
      position: 'absolute',
      right: 0,
      color: '#3e8d54'
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));


const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(PurchaseRecord); 
